<div class="container" fxFlex>
  <form [formGroup]="rootFormGroup" fxLayout="column" fxLayoutAlign="space-around stretch" (submit)="submit.emit(rootFormGroup.value)" #form>
    <mat-form-field>
      <mat-label i18n>Role</mat-label>
      <mat-select formControlName="imageRole" required>
        <mat-option [value]="imageRoles.photo" i18n>
          Photo
        </mat-option>
        <mat-option [value]="imageRoles.screenshot" i18n>
          Screenshot
        </mat-option>
        <mat-option [value]="imageRoles.graph" disabled i18n>
          Graph
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="rootFormGroup.get('imageRole').value === imageRoles.screenshot" formGroupName="screenshot">
      <mat-form-field>
        <mat-label i18n>Date it was taken</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Screenshot of</mat-label>
        <input matInput formControlName="description" required placeholder="the programm XY"/>
      </mat-form-field>
    </ng-container>
    <mat-form-field>
      <mat-label i18n>Author's name</mat-label>
      <input
        matInput
        formControlName="author"
        [required]="licensesFormField.value && (licensesFormField.value['enum']===licensesEnumAccessor.CC_BY || licensesFormField.value['enum']===licensesEnumAccessor.CC_BY_SA)"
        (input)="onAuthorInputChange($event)"
        placeholder="Type in three dots (...) to fill in your own name!"
        i18n-placeholder
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Author's Site</mat-label>
      <input matInput formControlName="authorUrl" type="url"/>
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>The work's title</mat-label>
      <input matInput formControlName="title" placeholder="e.g. Sunset at XYZ-Valley" i18n-placeholder/>
    </mat-form-field>
    <!--&lt;!&ndash;<mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="e.g. Screenshot from DD.MM.YYYY"/>
    </mat-form-field>&ndash;&gt;-->
    <mat-form-field>
      <mat-label i18n>Author's affiliation</mat-label>
      <input matInput formControlName="authorAffiliation" placeholder="e.g. your institution" i18n-placeholder/>
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Select License</mat-label>
      <mat-select formControlName="license" required #licensesFormField>
        <mat-option *ngFor="let license of licenses" [value]="license">
          {{license.name}} {{license.version}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>origin URL</mat-label>
      <input matInput formControlName="originUrl" placeholder="e.g. link to the image via a service" type="url" i18n-placeholder/>
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>origin name</mat-label>
      <input matInput formControlName="originName" placeholder="e.g. the name of the service hosting the image" i18n-placeholder/>
    </mat-form-field>
    <button mat-raised-button color="accent" [disabled]="!rootFormGroup.valid || disableButton">{{buttonText}}</button>
  </form>

</div>
